import Config from '../configs/config';
import Services from '../services/services';
import { isLegacyIE } from '../../../core/js/utils/generalUtils';
import { sanitizeURL } from '../../../core/js/utils/urlUtils';

class ViewModel {
    constructor() {

    }

    get(property){
        return this[property];
    }

    set(property,name,toggle = 'toggle'){
        if(property == 'viewStates'){
            toggle == 'toggle' ? this[property][name] = !this[property][name] : this[property][name] = toggle;
        }else if(property == 'events'){
            if(toggle !== "toggle") {
                this[property][name]['status'] = toggle;
            } else if(this[property][name]['status'] == false) {
                this[property][name]['status'] = true;
            } else{
                this[property][name]['status'] = false;
            }
        }
    }

    updateViewState(vs, value = '') {
        if (value === '') {
            this.viewStates[vs] = !this.viewStates[vs];
        } else {
            this.viewStates[vs] = value;
        }
        return Promise.resolve(this);
    }

    updateEvent(event, value = '') {
        if (value === '') {
            this.viewStates[event] = !this.viewStates[event];
        } else {
            this.viewStates[event] = value;
        }
    }

    /**
     * Change the url hash to the selector's data-link-name attribute value
     * @param {string} selector - DOM element
     */
    updatePushState(selector, store) {
        console.log("viewModel: updatePushState");
        const urlRequiresTrailingSlash = _.get(store, 'core.constants.urlsRequireTrailingSlash', false);
        const link = jQuery(selector).attr('data-link-name');
        const route = sanitizeURL(`${store.core.contextPath}account/${link}`, urlRequiresTrailingSlash);
        if(isLegacyIE()) {
            window.location = route;
        } else {
            return new Promise(function(resolve,reject){
                window.page(route);
                resolve(link);
            });
        }
    }

    /**
     * Change the url hash to the param passed in
     * @param {string} hash - order detail hash (ex 'order-details/A_RNO200010230');
     */
    updateOrderPushState(link) {
        console.log("viewModel: updateOrderPushState");

        return new Promise(function(resolve,reject){
            window.page('/' + link);
            resolve(link);
        });
    }

    disableTempStates() {
        this.viewStates.deleteSuccessModal = false;
        //        this.viewStates.showErrors = false;
        return Promise.resolve(true);
    }
}

export default ViewModel;
